<template>
  <el-dialog
    v-if="dialog"
    title="编辑教师荣誉"
    :visible.sync="dialog"
    :before-close="closed"
  >
    <el-form
      v-loading="saving"
      class="content-box"
      ref="elnewForm"
      :model="newForm"
      :rules="rules"
      label-width="200px"
    >
      <el-form-item label="奖项名称" prop="title">
        <el-input
          show-word-limit
          maxlength="100"
          size="small"
          placeholder="请输入"
          v-model="newForm.title"
        ></el-input>
      </el-form-item>
      <el-form-item label="获奖类别" prop="awardType">
        <el-radio-group v-model="newForm.awardType">
          <el-radio :label="0">教师个人获奖</el-radio>
          <el-radio :label="1">团队获奖</el-radio>
          <el-radio :label="2">指导学生获奖</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="校区" prop="school">
        <school-selector
          dicType="module"
          v-model="newForm.school"
          @change="schoolChange"
        ></school-selector>
      </el-form-item>
      <el-form-item label="获奖教师" prop="teacher">
        <author-selector
          :schoolCodes="newForm.school ? [newForm.school.schoolCode] : null"
          :multiple="false"
          v-model="newForm.teacher"
        ></author-selector>
      </el-form-item>
      <el-form-item label="获奖级别" prop="rankTemp">
        <dicSelector
          dicType="awardlevel"
          v-model="newForm.rankTemp"
        ></dicSelector>
      </el-form-item>
      <el-form-item label="获奖日期" prop="awardDate">
        <el-date-picker
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          v-model="newForm.awardDate"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="授予单位(机构)" prop="unit">
        <el-input
          show-word-limit
          maxlength="50"
          placeholder="请输入"
          v-model="newForm.unit"
        ></el-input>
      </el-form-item>
      <el-form-item label="获奖图片" prop="attach">
        <uploader
          style="display: inline-block"
          tipDesc="仅支持图片"
          list-type="picture-card"
          :limit="10"
          accept="image/*"
          :maxSize="30 * 1024 * 1024"
          :file-list.sync="newForm.attach"
        />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          style="width: 400px"
          type="textarea"
          autosize
          :rows="6"
          show-word-limit
          maxlength="200"
          placeholder="请输入"
          v-model="newForm.remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer text-center">
      <el-button @click="closed" size="small">取 消</el-button>
      <el-button type="primary" @click="onSave" :loading="saving" size="small"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>


<script>
import pagination from '@/components/Pagination.vue'
import AuthorSelector from '@/components/school/authorSelector.vue'
import dicSelector from '@/components/school/dicSelector.vue'
import schoolSelector from '@/components/school/schoolSelector.vue'
import uploader from '@/components/school/uploader.vue'
import { getData, postJson } from '@/http/fetch'
import { mapGetters } from 'vuex'

export default {
  name: 'honorPop',
  components: {
    uploader,
    pagination,
    dicSelector,
    AuthorSelector,
    schoolSelector
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    newPropForm: {
      type: Object
    }
  },
  data() {
    return {
      saving: false,

      loading: false,

      rankList: [],
      classifyList: [],
      tableData: [],
      newForm: {
        rankTemp: null,
        awardType: 0,
        teacher: null,
        classify: null,
        id: null,
        infoCode: null,
        school: null,
        schoolCode: null,
        title: null,
        attach: [],
        awardDate: '',
        checkStatus: null,
        unit: null,
        remark: null
      },
      rules: {
        attach: [
        	{ required: true, message: "上传图片", trigger: "change" }
        ],
        unit: [
        	{ required: true, message: "请输入授予单位(机构)", trigger: "change" }
        ],
        school: [{ required: true, message: '请输入分值', trigger: 'change' }],
        teacher: [
          { required: true, message: '请选择获奖教师', trigger: 'change' }
        ],
        awardType: [
          { required: true, message: '请选择获奖类别', trigger: 'change' }
        ],
        title: [{ required: true, message: '请输入获奖名称', trigger: 'blur' }],
        awardDate: [
          { required: true, message: '请选择获奖日期', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['schoolCode', 'operatorId', 'schoolCodes'])
  },
  created() {
    //编辑
    if (this.newPropForm && this.newPropForm.id) {
      this.newForm = this.newPropForm
      this.newForm.teacher = {'userId' : this.newPropForm.teacherId , 'userName' : this.newPropForm.teacherName}

    }
    this.getDic('honorAwardType').then((res) => {
      this.classifyList = res
    })
    this.getDic('level').then((res) => {
      this.rankList = res
    })
  },
  mounted() {},
  methods: {
    closed() {
      this.$emit('changeHonorPop', false)
    },
    schoolChange(e) {
      this.newForm.teacher = null
    },
    rankFormatter(row, column, cellValue, index) {
      let result = cellValue
      let find = this.rankList.find((f) => f.dicCode == cellValue)
      if (find) {
        result = find.dicName
      }
      return result
    },
    classifyFormatter(row, column, cellValue, index) {
      let result = cellValue
      let find = this.classifyList.find((f) => f.dicCode == cellValue)
      if (find) {
        result = find.dicName
      }
      return result
    },
    getDic(dicType) {
      return new Promise((resolve, reject) => {
        getData('/core/dic/getDictionaryList', {
          dicType
        }).then((res) => {
          if (res.length > 0) {
            res = res.map((m) => {
              return {
                dicCode: m.dicCode,
                dicName: m.dicName
              }
            })
            resolve(res)
          } else {
            reject()
          }
        })
      })
    },

    onSave() {
      this.$refs.elnewForm.validate((valid) => {
        if (valid) {
          this.saving = true
          let attach = this.newForm.attach.length
            ? JSON.stringify(
                this.newForm.attach.map((m) => {
                  return {
                    attachSize: m.attachSize,
                    attachType: m.attachType,
                    attachUrl: m.attachUrl
                  }
                })
              )
            : ''
          // 根据获奖类别设置classify参数
          let classify = 'honor' // 默认值：教师个人获奖
          if (this.newForm.awardType === 1) {
            classify = 'award' // 团队获奖
          } else if (this.newForm.awardType === 2) {
            classify = 'guideAward' // 指导学生获奖
          }
          postJson('/teacherAwardInfo/saveOrUpdateTeacherAward', {
            attach: attach,
            awardDate: this.newForm.awardDate,
            awardType: this.newForm.awardType,
            classify: classify,
            id: this.newForm.id ? this.newForm.id : null,
            infoCode: this.newForm.infoCode ? this.newForm.infoCode : null,
            checkStatus: this.newForm.checkStatus
              ? this.newForm.checkStatus
              : null,
            operatorId: this.operatorId,
            ranks: this.newForm.rankTemp.dicCode / 1,
            schoolCode: this.newForm.school.schoolCode,
            teacherId: this.newForm.teacher.userId,
            teacherName: this.newForm.teacher.userName,
            title: this.newForm.title,
            unit: this.newForm.unit,
            remark: this.newForm.remark
          })
            .then((res) => {
              this.saving = false
              this.$message.success('保存成功！')

              this.closed()
            })
            .catch()
            .finally(() => {
              this.saving = false
            })
        }
      })
    }
  }
}
</script>

<style>
</style>
